import { Box, Button, Fade, TextField } from '@mui/material'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import { useState } from 'react'
import { ITrackingFilter } from '../../../../core/types/CheckoutOrder'

const TrackerFilter = ({
  data,
  setData,
}: {
  data: ITrackingFilter
  setData: (value: ITrackingFilter) => void
}) => {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prev) => !prev)
  }

  return (
    <>
      <Box>
        <Button
          fullWidth
          variant="outlined"
          endIcon={
            <ArrowDropDownIcon
              sx={{
                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s ease',
              }}
            />
          }
          sx={{ textTransform: 'none', justifyContent: 'space-between' }}
          onClick={handleToggle}
        >
          Parâmetros de rastreamento
        </Button>
        <Fade in={open} mountOnEnter unmountOnExit>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
              mt: 1,
              p: 2,
              border: '1px solid #ccc',
              borderRadius: 1,
            }}
          >
            <TextField
              id="src_filter"
              label="src"
              variant="outlined"
              size="small"
              fullWidth
              value={data.src ?? ''}
              onChange={(e) => setData({ ...data, src: e.target.value })}
            />
            <TextField
              id="sck_filter"
              label="sck"
              variant="outlined"
              size="small"
              fullWidth
              value={data.sck ?? ''}
              onChange={(e) => setData({ ...data, sck: e.target.value })}
            />
            <TextField
              id="utm_campaign_filter"
              label="utm_campaign"
              variant="outlined"
              size="small"
              fullWidth
              value={data.utm_campaign ?? ''}
              onChange={(e) =>
                setData({ ...data, utm_campaign: e.target.value })
              }
            />
            <TextField
              id="utm_source_filter"
              label="utm_source"
              variant="outlined"
              size="small"
              fullWidth
              value={data.utm_source ?? ''}
              onChange={(e) => setData({ ...data, utm_source: e.target.value })}
            />
            <TextField
              id="utm_medium_filter"
              label="utm_medium"
              variant="outlined"
              size="small"
              fullWidth
              value={data.utm_medium ?? ''}
              onChange={(e) => setData({ ...data, utm_medium: e.target.value })}
            />
            <TextField
              id="utm_content_filter"
              label="utm_content"
              variant="outlined"
              size="small"
              fullWidth
              value={data.utm_content ?? ''}
              onChange={(e) =>
                setData({ ...data, utm_content: e.target.value })
              }
            />
            <TextField
              id="utm_term_filter"
              label="utm_term"
              variant="outlined"
              size="small"
              fullWidth
              value={data.utm_term ?? ''}
              onChange={(e) => setData({ ...data, utm_term: e.target.value })}
            />
          </Box>
        </Fade>
      </Box>
    </>
  )
}

export default TrackerFilter
